module.exports = __webpack_public_path__ + "static/media/service_subject_5.e97a0d7b.png";